<template>
  <div>
    <div
      class="text-xs-center pa-2"
      style="border: 1px solid #eee; float: left; border-radius: 10px"
    >
      <template v-if="baseUrl">
        <img
          ref="answer"
          style="width: 100%; max-width: 255px"
          :src="baseUrl.replace('?_ignored=', '')"
        />
      </template>
      <template v-if="!isRichVideo">
        <div class="primary--text caption">
          {{ showRichMessage ? 'Rich Message' : 'Line Image Map' }}
        </div>
        <v-btn
          color="primary"
          depressed
          @click="
            () => {
              if (!showRichMessage) {
                onclick()
              } else {
                show = true
              }
            }
          "
          >{{ $t('Edit') }}</v-btn
        >
        <v-dialog v-model="show" :fullscreen="!showRichMessage">
          <v-card style="overflow: hidden">
            <v-layout>
              <v-flex>
                <div class="primary--text headline pa-2">Image Map</div>
              </v-flex>
              <v-flex>
                <div class="text-xs-right">
                  <v-btn flat fab small @click="show = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <template v-if="showRichMessage">
              <v-card-text v-if="show">
                <intent-line-image-map-message
                  v-model="message"
                  :image_url_edit="baseUrl"
                  @onsave="onsave"
                  @oncancel="oncancel"
                ></intent-line-image-map-message>
              </v-card-text>
            </template>
            <template v-else>
              <iframe
                v-if="show"
                id="iframe-line-image-map-edit"
                :key="reRenderKey"
                :src="`https://line-image-map.zwiz.app/th?url=${locationOrigin}&t=${Date.now()}`"
                style="
                  height: 100%;
                  overflow: auto;
                  width: 100%;
                  border: none;
                  position: absolute;
                  inset: 60px 0 0;
                "
                sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
                allowfullscreen="true"
              />
            </template>
          </v-card>
        </v-dialog>
      </template>
    </div>
    <div class="clearfix"></div>
    <div class="caption mt-2 warning--text">
      {{ $t('Note: This messages will not be shown on facebook') }}
    </div>
  </div>
</template>

<script>
import jsonFormatter from 'json-string-formatter'
import IntentLineImageMapMessage from './IntentLineImageMapMessage'
export default {
  components: {
    IntentLineImageMapMessage
  },
  props: ['value'],
  data: function () {
    return {
      linkurl: '',
      hasLinkUrl: false,
      show: false,
      message: null,
      baseUrl: null,
      isRichVideo: false,
      reRenderKey: 0,
      locationOrigin: '',
      showRichMessage: false
    }
  },
  watch: {
    value: function (newVal) {
      var vm = this
      vm.baseUrl = newVal.baseUrl
      this.message = jsonFormatter.format(JSON.stringify(newVal))
    },
    show: function () {
      this.reRenderKey++
    }
  },
  mounted: function () {
    var vm = this
    vm.baseUrl = vm.value.baseUrl
    vm.isRichVideo = vm.value.is_rich_video && vm.value.is_rich_video === true
    vm.message = jsonFormatter.format(JSON.stringify(vm.value))
    vm.cached_message = jsonFormatter.format(JSON.stringify(vm.value))
    if (['basicimagemap'].includes(vm.value.type)) {
      this.showRichMessage = true
    }
    this.locationOrigin = window.location.origin
    this.reRenderKey++
  },
  beforeDestroy() {
    if (!this.showRichMessage) {
      window.removeEventListener(
        'message',
        (e) => {
          if (e.data) {
            this.handleListenEventMessage(e.data)
          }
        },
        false
      )
    }
  },
  methods: {
    handleListenEventMessage({ event_id, data }) {
      switch (event_id) {
        case 'zwiz-line-image-map-cancel':
          this.oncancel()
          break
        case 'zwiz-line-image-map-ready':
          this.onready()
          break
        case 'zwiz-line-image-map-edit':
          this.message = jsonFormatter.format(JSON.stringify(data))
          this.onsave()
          break
      }
    },
    onclick: function () {
      this.message = this.value
      this.show = true
      if (!this.showRichMessage) {
        window.addEventListener(
          'message',
          (e) => {
            if (e.data) {
              this.handleListenEventMessage(e.data)
            }
          },
          false
        )
      }
    },
    onready: function () {
      setTimeout(() => {
        if (document.querySelector('iframe#iframe-line-image-map-edit')) {
          const iframeLineImageMapEdit = document.querySelector('iframe#iframe-line-image-map-edit')
          iframeLineImageMapEdit.contentWindow.postMessage(
            {
              event_id: 'zwiz-line-image-map-edit',
              data: this.message
            },
            '*'
          )
        }
      }, 1000)
    },
    oncancel: function () {
      this.show = false
      this.message = this.cached_message
      this.showRichMessage = false
    },
    onsave: async function () {
      var vm = this
      vm.$emit('input', JSON.parse(vm.message))
      vm.message = jsonFormatter.format(vm.message)
      vm.show = false
      vm.cached_message = vm.message
      vm.showRichMessage = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentLineImageMap.vue